import { Winner } from "../../types";
import WinnerAvatar from "./WinnerAvatar";
import { BREAKPOINT } from "../../util";

type WinnerSelectProps = {
  winners: Winner[];
  selectedWinners: Winner[];
  setSelectedWinners: React.Dispatch<React.SetStateAction<Winner[]>>;
  isSelectVisible: boolean;
  containerWidth: number;
};

function WinnerSelect({
  winners,
  selectedWinners,
  setSelectedWinners,
  isSelectVisible,
  containerWidth,
}: WinnerSelectProps) {
  function avatarOnClick(
    targetWinner: string,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) {
    if (selectedWinners.find((winner) => winner.winner === targetWinner)) {
      setSelectedWinners(
        selectedWinners.filter((winner) => winner.winner !== targetWinner),
      );
      return;
    }

    const targetWinnerData = winners.find(
      (winner) => winner.winner === targetWinner,
    );

    if (!targetWinnerData) return;

    const newSelectedWinners = structuredClone(selectedWinners);
    newSelectedWinners.push(targetWinnerData);
    setSelectedWinners(newSelectedWinners);
  }

  if (!winners.length) return null;

  return (
    <div
      className="us-elections-widget__candidate-select-wrapper"
      style={{ display: isSelectVisible ? "block" : "none" }}
    >
      <div>
        {containerWidth >= BREAKPOINT && (
          <p>Selected candidates ({selectedWinners.length})</p>
        )}
        <button
          onClick={() => {
            setSelectedWinners(
              selectedWinners.length < winners.length
                ? structuredClone(winners)
                : [],
            );
          }}
        >
          {selectedWinners.length < winners.length ? "Select" : "Clear"} All
        </button>
      </div>
      <ul>
        {winners.map((winner, index) => (
          <li key={winner.winner}>
            <WinnerAvatar
              name={winner.winner}
              winnerColor={winner.winnerColor}
              onClick={(event) => avatarOnClick(winner.winner, event)}
              isSelected={Boolean(
                selectedWinners.find(
                  (itemWinner) => itemWinner.winner === winner.winner,
                ),
              )}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default WinnerSelect;
